module.exports = __webpack_public_path__ + "static/media/faloos.1afa7e2c.jpg";